import React from 'react';
import './Spinner.scss'

const Spinner = (props = {}) => {
    return (
        <div className="spiner">
      <div className="spin"></div>
    </div>
    );
}

export default Spinner;
